export type LocationType = 1 | 2 | 3 | 4 | 5;
interface ILocationTypeEnum {
    Building: LocationType;
    Level: LocationType;
    Department: LocationType;
    Room: LocationType;
    Cabinet: LocationType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 1, text: 'Pastatas', code: null, type: null, group: null },
    { key: 2, text: 'Aukštas', code: null, type: null, group: null },
    { key: 3, text: 'Padalinys', code: null, type: null, group: null },
    { key: 4, text: 'Kabinetas', code: null, type: null, group: null },
    { key: 5, text: 'Vieta', code: null, type: null, group: null }
];

export const locationType: ILocationTypeEnum = {
    Building: 1,
    Level: 2,
    Department: 3,
    Room: 4,
    Cabinet: 5,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
